module.exports = __webpack_public_path__ + "static/media/portfolio6.d78fdf45.jpg";